import { faSignOutAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Nav, Navbar, Popover, Whisper } from 'rsuite';
import { authActions } from '../../redux/actions/auth.actions';
import DropdownLanguage from './language/DropdownLanguage';

type Props = {
    expanded: boolean;
    auth: Record<string, any>;
    logout: Function;
};

type State = {};

const mapDispatchToProps = (dispatch: Function) => ({
    logout: () => dispatch(authActions.logout(false)),
});
class NavbarToggleMobile extends React.Component<Props, State> {
    render() {
        return (
            <Navbar
                appearance="default"
                className="nav-toggle"
                style={{ display: this.props.expanded ? 'block' : 'none' }}>
                <Navbar.Body>
                    <Nav style={{ width: '100%' }}>
                        <DropdownLanguage />
                        <Whisper
                            trigger="click"
                            placement="topStart"
                            speaker={
                                <Popover title={this.props.auth.user.name}>
                                    <Button onClick={() => this.props.logout()} block color="orange">
                                        <FontAwesomeIcon icon={faSignOutAlt} className="margin-right-10" />
                                        <FormattedMessage id="sidenav.logout" />
                                    </Button>
                                </Popover>
                            }>
                            <Nav.Item style={{ width: 56, textAlign: 'center' }}>
                                <FontAwesomeIcon size="3x" icon={faUserCircle} />
                            </Nav.Item>
                        </Whisper>
                    </Nav>
                </Navbar.Body>
            </Navbar>
        );
    }
}

function mapStateToProps(state) {
    const { auth } = state;

    return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavbarToggleMobile);
